var _defs, _g, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 270,
  height: 155
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h121v120.999H0z",
  "data-name": "Rectangle 129"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 644091"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f5f5f5",
  d: "M0 0h270v155H0z",
  "data-name": "Rectangle 124"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 236"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_svg__a)",
  "data-name": "Group 235",
  transform: "translate(74.5 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M120.5 60.5a60 60 0 1 1-60-60 60 60 0 0 1 60 60",
  "data-name": "Path 2876"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bcc1c9",
  d: "M60.5 121a60.22 60.22 0 0 1-33.827-10.332A60.67 60.67 0 0 1 4.755 84.049a60.42 60.42 0 0 1 5.578-57.375A60.68 60.68 0 0 1 36.951 4.755a60.42 60.42 0 0 1 57.376 5.578 60.67 60.67 0 0 1 21.918 26.617 60.42 60.42 0 0 1-5.578 57.375 60.67 60.67 0 0 1-26.617 21.92A60.1 60.1 0 0 1 60.5 121m0-120a59.22 59.22 0 0 0-33.266 10.162A59.67 59.67 0 0 0 5.676 37.34a59.42 59.42 0 0 0 5.486 56.426 59.68 59.68 0 0 0 26.179 21.557 59.42 59.42 0 0 0 56.427-5.486 59.67 59.67 0 0 0 21.557-26.177 59.42 59.42 0 0 0-5.486-56.426A59.67 59.67 0 0 0 83.661 5.676 59.1 59.1 0 0 0 60.5 1",
  "data-name": "Path 2877"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353c3c",
  d: "M79.618 88.662H37.266a5.044 5.044 0 0 1-4.929-4.93V41.381h1.7V83.7a3.346 3.346 0 0 0 3.26 3.261h42.321Zm4.105-8.19h-.01l-38.254-.007a5.04 5.04 0 0 1-4.929-4.93V37.268a5.04 5.04 0 0 1 4.929-4.93h38.274a5.044 5.044 0 0 1 4.93 4.93v38.274a5.044 5.044 0 0 1-4.93 4.93ZM45.49 78.765l38.213.007a3.346 3.346 0 0 0 3.26-3.261V37.3a3.346 3.346 0 0 0-3.263-3.262H45.49a3.344 3.344 0 0 0-3.26 3.26V75.5a3.344 3.344 0 0 0 3.26 3.265",
  "data-name": "Path 2878"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M56.266 41.052a4.719 4.719 0 1 1-4.719 4.719 4.724 4.724 0 0 1 4.719-4.719m0 7.738a3.019 3.019 0 1 0-3.019-3.019 3.02 3.02 0 0 0 3.019 3.019",
  "data-name": "Ellipse 1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M77.979 68.38H51.28a.85.85 0 0 1-.678-1.363l6.354-8.4a.85.85 0 0 1 1.348-.011l3.965 5.073 6.364-8.342a.85.85 0 0 1 1.358.009l8.671 11.675a.85.85 0 0 1-.682 1.357Zm-24.991-1.7h23.3L69.3 57.268l-6.347 8.319a.85.85 0 0 1-1.345.008l-3.962-5.069Z",
  "data-name": "Path 2879"
}))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#022a3a",
  d: "M196 0h74v31h-74z",
  "data-name": "Rectangle 18373"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#fff",
  fontFamily: "Lato-Bold, Lato",
  fontSize: 14,
  fontWeight: 700,
  transform: "translate(233 21)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -13.769,
  y: 0
}, "IMG"))));
export { SvgImg as ReactComponent };
export default __webpack_public_path__ + "d8652f0b2877b20771c9e3d1a8e24b96.svg";